<script setup lang="ts">
defineProps<{ total: number; current: number }>()
</script>

<template>
  <div aria-hidden="true" class="ui-steps">
    <div v-for="step in total" :key="step" class="ui-steps__bar" :class="{ 'ui-steps__bar--done': step <= current }"></div>
  </div>
</template>

<style scoped>
.ui-steps {
  display: flex;
  gap: 6px;
  padding: 0 24px;
  margin-top: -1px;
}
.ui-steps__bar {
  flex: 1;
  height: 3px;
  border-radius: 2px;
  background: var(--separator);
}
.ui-steps__bar--done {
  background: var(--accent);
}
</style>
